import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/close.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex justify-center items-center fixed inset-y-0 right-0 overflow-x-hidden overflow-y-hidden z-50 w-full"
}
const _hoisted_2 = { class: "flex relative w-1/2 h-auto" }
const _hoisted_3 = { class: "flex flex-col bg-white w-full h-auto rounded-2xl shadow p-8" }
const _hoisted_4 = { class: "flex flex-row justify-between mb-8" }
const _hoisted_5 = {
  key: 0,
  class: "font-semibold text-lg"
}
const _hoisted_6 = {
  key: 1,
  class: "font-semibold text-lg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "capitalize" }
const _hoisted_11 = { class: "flex-col w-60" }
const _hoisted_12 = { class: "flex flex-row items-center justify-between" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Amount:", -1)
const _hoisted_14 = { class: "uppercase" }
const _hoisted_15 = { class: "flex flex-row items-center justify-between" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Fees & taxes:", -1)
const _hoisted_17 = { class: "uppercase" }
const _hoisted_18 = { class: "flex flex-row items-center justify-between" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Total:", -1)
const _hoisted_20 = { class: "uppercase" }
const _hoisted_21 = { class: "flex flex-col bg-gray-100 rounded p-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "Reason", -1)
const _hoisted_23 = { class: "mt-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "h-0.5 bg-gray-300 w-full my-6" }, null, -1)
const _hoisted_25 = { class: "flex flex-row justify-between items-center" }
const _hoisted_26 = { class: "flex flex-col" }
const _hoisted_27 = { class: "flex flex-row items-center justify-end" }
const _hoisted_28 = {
  key: 0,
  class: "bg-red-500 rounded-full w-3 h-3 mr-3"
}
const _hoisted_29 = {
  key: 1,
  class: "bg-blue-800 rounded-full w-3 h-3 mr-3"
}
const _hoisted_30 = { class: "capitalize" }
const _hoisted_31 = {
  key: 1,
  class: "bg-black opacity-50 fixed inset-y-0 right-0 z-40 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.openReason)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.reimbursement.status === 'denied')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Reason of denied"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "Reason")),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                }, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex flex-row items-center justify-between rounded-2xl p-4 mb-4", {
                'bg-gray-300': _ctx.reimbursement.status === 'denied',
                shadow:
                  _ctx.reimbursement.status === 'approved' ||
                  _ctx.reimbursement.status === 'paid',
              }])
                }, [
                  _createVNode(_component_UserCard, {
                    firstName: _ctx.reimbursement.user.first_name,
                    lastName: _ctx.reimbursement.user.last_name,
                    position: "Frontend Developer"
                  }, null, 8, ["firstName", "lastName"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.reimbursement.detail.replaceAll("_", " ")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", _hoisted_14, " $" + _toDisplayString((_ctx.reimbursement.original_amount / 100).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )) + "(" + _toDisplayString(_ctx.reimbursement.currency) + ") ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, " $" + _toDisplayString((_ctx.reimbursement.original_fee / 100).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )) + "(" + _toDisplayString(_ctx.reimbursement.currency) + ") ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", _hoisted_20, " $" + _toDisplayString((_ctx.reimbursement.original_total / 100).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )) + "(" + _toDisplayString(_ctx.reimbursement.currency) + ") ", 1)
                    ])
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.reimbursement.note), 1)
                ])
              ]),
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                  class: "btn-outline-sm"
                }, " Close "),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    (_ctx.reimbursement.status === 'denied')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                      : (_ctx.reimbursement.status === 'approved')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                        : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.reimbursement.status), 1)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.openReason)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31))
      : _createCommentVNode("", true)
  ]))
}